import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
import { LEGAL_DOCUMENTS } from './legal-content';

@Component({
  selector: 'app-legal-page',
  imports: [],
  templateUrl: './legal-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './legal-page.component.css'
})
export class LegalPageComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private sanitizer = inject(DomSanitizer);

  content = signal<SafeHtml>('');

  /**
   * Renders synchronously on the server as well as the browser: the markdown is
   * bundled at build time (see `legal-content.ts`), so these routes prerender to
   * real HTML instead of the empty document a runtime fetch used to leave behind.
   */
  ngOnInit(): void {
    const file = this.route.snapshot.data['file'];
    const md = LEGAL_DOCUMENTS[file];
    if (!md) return;
    const html = marked.parse(md, { async: false });
    this.content.set(this.sanitizer.bypassSecurityTrustHtml(html));
  }
}
